/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteOrgUploadDataAsync$Json } from '../fn/diagnose/delete-org-upload-data-async-json';
import { DeleteOrgUploadDataAsync$Json$Params } from '../fn/diagnose/delete-org-upload-data-async-json';
import { deleteOrgUploadDataAsync$Plain } from '../fn/diagnose/delete-org-upload-data-async-plain';
import { DeleteOrgUploadDataAsync$Plain$Params } from '../fn/diagnose/delete-org-upload-data-async-plain';
import { DeleteOrgUploadDataResponse } from '../models/delete-org-upload-data-response';

@Injectable({ providedIn: 'root' })
export class DiagnoseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deleteOrgUploadDataAsync()` */
  static readonly DeleteOrgUploadDataAsyncPath = '/diagnose/delete-org-upload-data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOrgUploadDataAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteOrgUploadDataAsync$Plain$Response(params?: DeleteOrgUploadDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrgUploadDataResponse>> {
    return deleteOrgUploadDataAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOrgUploadDataAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteOrgUploadDataAsync$Plain(params?: DeleteOrgUploadDataAsync$Plain$Params, context?: HttpContext): Observable<DeleteOrgUploadDataResponse> {
    return this.deleteOrgUploadDataAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteOrgUploadDataResponse>): DeleteOrgUploadDataResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOrgUploadDataAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteOrgUploadDataAsync$Json$Response(params?: DeleteOrgUploadDataAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrgUploadDataResponse>> {
    return deleteOrgUploadDataAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOrgUploadDataAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteOrgUploadDataAsync$Json(params?: DeleteOrgUploadDataAsync$Json$Params, context?: HttpContext): Observable<DeleteOrgUploadDataResponse> {
    return this.deleteOrgUploadDataAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteOrgUploadDataResponse>): DeleteOrgUploadDataResponse => r.body)
    );
  }

}
